import React, { lazy, Suspense } from 'react';
import ReactDOM from "react-dom/client";
import reportWebVitals from './reportWebVitals';

const LazyApp = lazy(() => import('./App'))

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <Suspense fallback={null}>
      <LazyApp />
    </Suspense>
  </React.StrictMode>
);

reportWebVitals();
